/** Stable logical identities for this capability's owned fixed UDO templates. */
export enum B2bQuotationEngineWorkspaceCapabilityUdoTemplateKey {
    quotation = "a1a175d0-ced1-4e4a-8a1c-455062215eed",
    lineItem = "7d4b64ef-7f54-486a-8169-8f0d8f28c21b",
}
